module.exports = __webpack_public_path__ + "static/media/logo.b8091ecf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/img/logo.svg
// module id = 501
// module chunks = 4